import "./BoxScore.css";
import Spinner from "../../../../../components/Spinner";
import { useQuery } from "@apollo/client";
import { BADMINTON_STATS } from "../../../../../api/fixture";
import captureException from "../../../../../utils/captureException";

export default function BoxScore({
  periods,
  fixtureId,
  homePlayer,
  awayPlayer,
}) {
  const { loading, error, data } = useQuery(BADMINTON_STATS, {
    variables: { id: fixtureId },
  });

  if (error) {
    captureException({
      error,
      info: {
        type: "query",
        component: "Fixture.BadmintonStats.BoxScore",
        query: "BADMINTON_STATS",
      },
    });
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    return <Spinner />;
  }

  const stats = data?.fixture?.stats;
  const participantType = data?.fixture?.event?.participantType;
  const periodsWithScores = periods.map((period) => ({
    ...period,
    homeScore: stats.filter(
      (s) =>
        s.statType?.name === "Point Won" &&
        s.fixturePeriod?.id === period.id &&
        (participantType === "INDIVIDUAL"
          ? s.profile?.id === homePlayer?.profile?.id
          : s.organization?.id === homePlayer?.organization?.id)
    ).length,
    awayScore: stats.filter(
      (s) =>
        s.statType?.name === "Point Won" &&
        s.fixturePeriod?.id === period.id &&
        (participantType === "INDIVIDUAL"
          ? s.profile?.id === awayPlayer?.profile?.id
          : s.organization?.id === awayPlayer?.organization?.id)
    ).length,
  }));

  return (
    <div className="badminton-box-score-mobile">
      <div className="badminton-box-score-mobile__column players">
        <div className="badminton-box-score-mobile__column__label">
          {participantType === "INDIVIDUAL" ? "PLAYER" : "TEAM"}
        </div>
        <div className="badminton-box-score-mobile__column__value">
          <div className="badminton-box-score-mobile__column__value__image"></div>
          {homePlayer?.profile?.name || homePlayer?.organization?.name}
        </div>
        <div className="badminton-box-score-mobile__column__value">
          <div className="badminton-box-score-mobile__column__value__image"></div>
          {awayPlayer?.profile?.name || awayPlayer?.organization?.name}
        </div>
      </div>

      {periodsWithScores.map((period) => (
        <div className="badminton-box-score-mobile__column period">
          <div className="badminton-box-score-mobile__column__label">
            {period.label.toUpperCase()}
          </div>
          <div
            className={
              "badminton-box-score-mobile__column__value " +
              (period.homeScore > period.awayScore ? "bold" : "")
            }
          >
            {period.homeScore}
          </div>
          <div
            className={
              "badminton-box-score-mobile__column__value " +
              (period.awayScore > period.homeScore ? "bold" : "")
            }
          >
            {period.awayScore}
          </div>
        </div>
      ))}
    </div>
  );
}
